import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { SHIFT_PATTERNS_PATH } from 'src/hooks/useQueryShiftPatterns';
import { ShiftPatternRequestBody } from 'src/pages/TruckShifts/patternForm';

export const useMutationShiftPatterns = () => {
  const queryClient = useQueryClient();
  // パターン更新/削除は稼働表セル（shiftPattern.name/color、削除時の shift_pattern_id nullify）にも影響するため
  // truck_shifts のキャッシュ（staleTime: Infinity の別キー）も prefix invalidate する。
  const invalidate = () => {
    void queryClient.invalidateQueries({
      queryKey: ['useQueryShiftPatterns']
    });
    void queryClient.invalidateQueries({
      queryKey: ['useQueryTruckShifts']
    });
  };

  return {
    create: useMutation({
      mutationFn: (body: ShiftPatternRequestBody) => axios.post(SHIFT_PATTERNS_PATH, body),
      onSuccess: invalidate
    }),
    update: useMutation({
      mutationFn: ({ id, body }: { id: number; body: ShiftPatternRequestBody }) => axios.patch(`${SHIFT_PATTERNS_PATH}/${id}`, body),
      onSuccess: invalidate
    }),
    destroy: useMutation({
      mutationFn: (id: number) => axios.delete(`${SHIFT_PATTERNS_PATH}/${id}`),
      onSuccess: invalidate
    }),
  };
};
